<template>
        <b-container>
            <div class="part-intro__header">
                <part-intro-header 
                    :part="header" 
                    :icon="icon" 
                    :variant="variant"
                />
            </div>
            <b-row>
                <b-col>
                    <slot />
                </b-col>
            </b-row>
            <div class="w-100 interaction-container__ctrl-button-container" fluid>
                <b-row class="h-100" align-v="center" align-h="center">
                    <b-col cols="8" sm="6" md="4">
                        <control-button
                            class="w-100 interaction-container__ctrl-button"
                            v-if="!buttonHidden"
                            :isLoading="isLoading"
                            :disabled="buttonDisabled"
                            @click="handleNext"
                        >
                            {{ $t('INTERACTION_BASE_NEXT').toUpperCase() }}
                        </control-button>
                    </b-col>
                </b-row>
            </div>
        </b-container>
</template>
<script>
import partIntroHeader from '@/components/ui/partIntroHeader'
import controlButton from '@/components/ui/controlButton'

export default {
    name: 'partIntroPage',
    components: {
        'part-intro-header': partIntroHeader,
        'control-button': controlButton,
    },
    props: {
        header: {
            type: String
        },
        icon: {
            type: String
        },
        variant: {
            type: String
        },
        buttonDisabled: {
            type: Boolean
        },
        buttonHidden: {
            type: Boolean
        },
        isLoading: {
            type: Boolean
        }

    },
    methods: {
        handleNext() {
            this.$emit('click')
        }
    }
}
</script>